import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const style: CSSResult = css`
  .basket-container {
    padding: ${csSpacing.spacing06};
    background-color: ${csColorBackground.secondary};
  }

  .basket-buttons {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    gap: ${csSpacing.spacing04};
    padding-top: ${csSpacing.spacing06};
  }
`
